import { EditorTools } from '@progress/kendo-react-editor';

const colorToolSettings = {
    style: 'color',
    defaultItem: { text: 'No Color', value: '' },
    items: [
        { text: 'Blue', value: '#13316e' },
        { text: 'Yellow', value: '#FFFF00' },
        { text: 'Red', value: '#ff0000' }
        
    ]
};

const MyColorTool = EditorTools.createStyleDropDownList(colorToolSettings);

export default MyColorTool;